import {
  EBAY_POPUP_HEIGHT,
  EBAY_POPUP_WIDTH,
  EBAY_POPUP_WINDOW_NAME,
} from './constants';

// Markup copied from @depop/web-thrift-ui LoadingOnSurfaceLight (md)
const LOADING_ICON_SVG = `<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="2.667" height="6.667" x="10.586" y="8.7" fill="#3c3c43" opacity=".87" rx="1.333" transform="rotate(135 10.586 8.7)"/>
  <rect width="2.667" height="6.667" x="8.667" y="10.667" fill="#3c3c43" opacity=".75" rx="1.333" transform="rotate(90 8.667 10.667)"/>
  <rect width="2.667" height="6.667" x="8.7" y="13.414" fill="#3c3c43" opacity=".63" rx="1.333" transform="rotate(45 8.7 13.414)"/>
  <rect width="2.667" height="6.667" x="10.667" y="15.333" fill="#3c3c43" opacity=".51" rx="1.333"/>
  <rect width="2.667" height="6.667" x="20.016" y="18.128" fill="#3c3c43" opacity=".39" rx="1.333" transform="rotate(135 20.016 18.128)"/>
  <rect width="2.667" height="6.667" x="22" y="10.667" fill="#3c3c43" opacity=".27" rx="1.333" transform="rotate(90 22 10.667)"/>
  <rect width="2.667" height="6.667" x="18.13" y="3.986" fill="#3c3c43" opacity=".15" rx="1.333" transform="rotate(45 18.13 3.986)"/>
  <rect width="2.667" height="6.667" x="10.667" y="2" fill="#3c3c43" rx="1.333"/>
</svg>`;

const LOADING_HTML = `<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <style>
      body {
        margin: 0;
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      svg {
        animation: spin 1s steps(8) infinite;
      }
      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
    </style>
  </head>
  <body>${LOADING_ICON_SVG}</body>
</html>`;

export function openEbayPopup(title: string): Window | null {
  const left =
    (window.screenLeft ?? window.screenX) +
    (window.outerWidth - EBAY_POPUP_WIDTH) / 2;
  const top =
    (window.screenTop ?? window.screenY) +
    (window.outerHeight - EBAY_POPUP_HEIGHT) / 2;

  const popup = window.open(
    '',
    EBAY_POPUP_WINDOW_NAME,
    `width=${EBAY_POPUP_WIDTH},height=${EBAY_POPUP_HEIGHT},left=${left},top=${top},menubar=no,toolbar=no,resizable=yes,scrollbars=yes`
  );

  if (!popup) {
    return null;
  }

  popup.document.write(LOADING_HTML);
  popup.document.close();
  popup.document.title = title;

  return popup;
}
